module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroidDark.d57e1ba0.svg";